import React, { useState, useEffect } from 'react';
import { fetchUserPosts } from '../../services/api';

const DEFAULT_FEATURED_IMAGE =
    'https://res.cloudinary.com/dnbbm9vzi/image/upload/v1736181865/web_development___website_webpage_browser_ad_advertisement_man_people_ibpgaq.png';

const getCloudinaryUrl = (img) => {
    if (!img) return DEFAULT_FEATURED_IMAGE;
    if (img.includes('image/upload/')) {
        return `https://res.cloudinary.com/dbm8xbouw/${img}`;
    }
    return `https://res.cloudinary.com/dbm8xbouw/image/upload/${img}`;
};

const UserPosts = ({ language = 'en' }) => {
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const getPosts = async () => {
            setLoading(true);
            try {
                const fetchedPosts = await fetchUserPosts({ language });
                setPosts(fetchedPosts);
            } catch (err) {
                console.error(err);
                setError('Failed to fetch user-published articles.');
            } finally {
                setLoading(false);
            }
        };

        getPosts();
    }, [language]);

    if (loading) return <div className="text-center mt-5">Loading...</div>;
    if (error) return <div className="text-center mt-5 text-danger">{error}</div>;
    if (!posts.length) return <div className="text-center mt-5">No articles found.</div>;

    return (
        <div className="container mt-5">
            <h2 className="mb-5 fw-bold">| JESSSTER COMMUNITY</h2>
            <div className="row d-flex">
                {/* Left Column */}
                <div className="col-md-6 d-flex flex-column">
                    {posts.slice(0, 1).map((post) => (
                        <a
                            key={post.id}
                            href={`/user-posts/${post.slug}`}
                            className="text-decoration-none text-dark mb-4"
                        >
                            <div
                                className="d-flex align-items-center shadow-sm p-3"
                                style={{ backgroundColor: '#dee2e6', borderRadius: '5px', height: '348px', transition: 'all 0.3s ease', cursor: 'pointer' }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.backgroundColor = '#dbeafe'; // subtle highlight
                                    e.currentTarget.style.transform = 'translateY(-5px)'; // lift
                                    e.currentTarget.style.boxShadow = '0 8px 20px rgba(0,0,0,0.15)'; // shadow
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.backgroundColor = '#E5E7EB';
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.1)'; // optional reset shadow
                                }}
                            >

                                <div style={{ width: '40%', height: '100%', overflow: 'hidden', flexShrink: 0, borderRadius: '5px' }}>
                                    <img
                                        src={getCloudinaryUrl(post.featured_image)}
                                        alt={post.title}
                                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                        onError={(e) => { e.currentTarget.src = DEFAULT_FEATURED_IMAGE; }}
                                    />
                                </div>
                                <div className="ms-3" style={{ flex: 1 }}>
                                    <h5
                                        className="mb-0"
                                        style={{
                                            whiteSpace: 'normal',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            display: '-webkit-box',
                                            WebkitLineClamp: 3,
                                            WebkitBoxOrient: 'vertical',
                                            maxHeight: '4.5em',
                                            fontWeight: 'bold',
                                        }}
                                    >
                                        {post.title}
                                    </h5>
                                </div>
                            </div>
                        </a>
                    ))}
                </div>

                {/* Right Column */}
                <div className="col-md-6 d-flex flex-column">
                    {posts.slice(1, 4).map((post) => (
                        <a
                            key={post.id}
                            href={`/user-posts/${post.slug}`}
                            className="text-decoration-none text-dark mb-4"
                        >
                            <div
                                className="d-flex align-items-center shadow-sm p-3 small-post"
                                style={{ backgroundColor: '#dee2e6', borderRadius: '5px', height: '100px', transition: 'all 0.3s ease', cursor: 'pointer' }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.backgroundColor = '#dbeafe';
                                    e.currentTarget.style.transform = 'translateY(-3px)';
                                    e.currentTarget.style.boxShadow = '0 6px 15px rgba(0,0,0,0.12)';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.backgroundColor = '#E5E7EB';
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.1)';
                                }}
                            >

                                <div style={{ width: '20%', height: '100%', overflow: 'hidden', flexShrink: 0, borderRadius: '5px' }}>
                                    <img
                                        src={getCloudinaryUrl(post.featured_image)}
                                        alt={post.title}
                                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                        onError={(e) => { e.currentTarget.src = DEFAULT_FEATURED_IMAGE; }}
                                    />
                                </div>
                                <div className="ms-3" style={{ flex: 1 }}>
                                    <h5
                                        className="mb-0"
                                        style={{
                                            whiteSpace: 'normal',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            display: '-webkit-box',
                                            WebkitLineClamp: 2,
                                            WebkitBoxOrient: 'vertical',
                                            maxHeight: '3em',
                                            fontWeight: 'bold',
                                        }}
                                    >
                                        {post.title}
                                    </h5>
                                </div>
                            </div>
                        </a>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default UserPosts;
